import type { OIDCUser } from '@/infra/auth'
import type { UserDisplayInfo } from '../types'

export function useUserDisplayInfo(user: OIDCUser | null | undefined): UserDisplayInfo {
  if (!user?.profile) {
    return {
      displayName: 'User',
      email: null,
      initials: 'U',
    }
  }

  const profile = user.profile
  const displayName =
    profile.name ??
    profile.preferred_username ??
    profile.given_name ??
    profile.nickname ??
    profile.sub ??
    profile.email?.split('@')[0] ??
    'User'

  const email = profile.email ?? null
  const initials = displayName.charAt(0).toUpperCase()

  return { displayName, email, initials }
}
